import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorsModule } from './Erros/erros.module';
import { HomeModule } from './Home/home.module';
import { TCommonApiModule } from '@totvs/common-api';

//#region PO-UI modules
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { PoModule, PoI18nModule, PoI18nConfig } from '@po-ui/ng-components';
//#endregion

//#region i18n
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorToken } from './Context/interceptors/interceptortoken.service';
import { generalPt } from './i18n/general-pt';
import { generalEn } from './i18n/general-en';
import { generalEs } from './i18n/general-es';
//#endregion


//#region Configuração dos idiomas
const i18nConfig: PoI18nConfig = {
  default: {
    context: 'general',
    language: 'pt'
  },
  contexts: {
    general: {
      'pt': generalPt,
      'en': generalEn,
      'es': generalEs
    }
  }
};
//#endregion

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ErrorsModule,
        HomeModule,
        PoTemplatesModule,
        PoModule,
        PoI18nModule.config(i18nConfig),
        TCommonApiModule,
        FormsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorToken, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        {
          provide: 'ICONS_DICTIONARY',
          useValue: 'PoIconDictionary'
        }
    ] })
export class AppModule { }
